import React from "react";
import "./index.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress } from "@mui/material";
import {
  // useDispatch,
  useSelector,
} from "react-redux";
import fetch from "../../auth/FetchInterceptor.js";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import MainDepartment from "component/shared/main-department/MainDepartment";
import AboutDepartment from "component/shared/about-department/AboutDepartment";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
// import { API_BASE_URL } from "configs/AppConfig";
import ChevronIcon from "svg-icons/chevron-icon";
import ClearIcon from "@mui/icons-material/Clear";
import { LabelLangString } from "component/LabelLang/label-lang";
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";

function Newsletters() {
  const intl = useIntl();

  // const dir = useSelector(({ theme }) => theme.direction);
  // const userInfo = useSelector(({ auth }) => auth);
  // const dispatch = useDispatch();
  const currentLocale = useSelector(({ theme }) => theme.locale);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

        
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/newsletters", title: "Newsletters Page" });
  }, []);


  const getUserSubscriptions = useSWR({
    url: END_POINTS.USER_PUBLICATION_SUBSCRIPTIONS,
  });

  const getPublicationsData = useSWR({
    url: END_POINTS.GET_ALL_PUBLICATIONS,
  });

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.NEWSLETTERS_DEPARTMENT_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.NEWSLETTERS_DEPARTMENT_ID}`,
  });

  const [publicationFilterText, setPublicationFilterText] = React.useState("");

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // React.useEffect(() => {
  //   setExpanded(
  //     `panel${getPublicationsData?.data?.data[0]?.subSubjects[0]?.id}`
  //     `panel${0}`
  //   );
  // }, []);

  React.useEffect(() => {
    var result = getUserSubscriptions?.data?.data?.map((item) => {
      return {
        [item?.publicationId]: true,
      };
    });
    Array.isArray(result) && setCheckedItems(Object.assign({}, ...result));
  }, [getUserSubscriptions?.data?.data]);

  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectAll, setSelectAll] = React.useState({});

  const handleSelectAllChange = (list, subSubjectId) => {
    const newCheckedItems = { ...checkedItems };
    const newSelectAll = !selectAll[subSubjectId];

    list.find((item) => item.id === subSubjectId)
      .publications.forEach((el) => {
        newCheckedItems[el.id] = newSelectAll;
      });

    setCheckedItems(newCheckedItems);
    setSelectAll((prev) => ({
      ...prev,
      [subSubjectId]: newSelectAll,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };


  const renderPublicationsData = () => {
    const publicationsData =
      getPublicationsData.error ||
      getPublicationsData.isLoading ||
      getPublicationsData.data === undefined
        ? []
        : getPublicationsData.data.data;
    const rendering = publicationsData?.map(
      ({ id, name, translations, subSubjects }) => (
        <div key={id} className="cont-main-subject">
          <li>
            {LabelLangString({
              id: "name",
              currentLocale: currentLocale,
              defaultValue: name,
              translations: translations,
            })}
          </li>
          <div className="cont-accordions">
            {subSubjects
            .filter(
              (x) =>
                x.publications.filter((x) =>
                  x.name
                    ?.toLowerCase()
                    .includes(publicationFilterText.toLowerCase())
                )?.length > 0 ||
                x.publications?.filter((x) =>
                  x.publicationTranslations[0]?.name
                    ?.toLowerCase()
                    .includes(publicationFilterText.toLowerCase())
                )?.length > 0
            )
            .map(({ id, name, translations, publications }, index) => (
              <Accordion
                key={id}
                className="mb-2"
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
              >
                <AccordionSummary
                  aria-controls={`panel${index}bh-content`}
                  id={`panel${index}bh-header`}
                  className={"coll-item-headr"}
                >
                  <div
                    className={`icon ${
                      expanded === `panel${index}` ? "open" : "close"
                    }`}
                  >
                    <i className="fas fa-minus"></i>
                    <i className="fas fa-plus"></i>
                  </div>
                  <h5>
                    {LabelLangString({
                      id: "name",
                      currentLocale: currentLocale,
                      defaultValue: name,
                      translations: translations,
                    })}
                  </h5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ textAlign: "start", paddingInlineStart: "2rem" }}
                  className="coll-dateils"
                >
                  <div className="row gy-0 mt-3 justify-content-center align-items-center">
                    <div className="col-12">
                      <div>
                        <div className="mb-3 fw-bold d-flex">
                          <input
                            type="checkbox"
                            name={`selectAll-${id}`}
                            id={`selectAll-${name}`}
                            checked={selectAll[id] || false}
                            onChange={() =>
                              handleSelectAllChange(subSubjects, id)
                            }
                            className="form-check-input"
                            style={{ marginInlineEnd: "0.7rem" }}
                          />
                          <label htmlFor={`selectAll-${name}`}>
                            {intl.formatMessage({
                              id: "select-all-publications",
                            })}{" "}
                            {LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: name,
                              translations: translations,
                            })}
                          </label>
                        </div>
                        <div style={{ marginInlineStart: "1.5rem" }}>
                          {publications.map(
                            ({ id, name, publicationTranslations }) => (
                              <div key={id} className="d-flex mb-2">
                                <input
                                  type="checkbox"
                                  name={id}
                                  id={name}
                                  checked={checkedItems[id] || false}
                                  onChange={handleCheckboxChange}
                                  className="form-check-input"
                                  style={{ marginInlineEnd: "0.7rem" }}
                                />
                                <label htmlFor={name}>
                                  {LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue: name,
                                    translations: publicationTranslations,
                                  })}
                                </label>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      )
    );

    return rendering;
  };


  const getCheckedItems = () => {
    return Object.keys(checkedItems)?.filter((key) => checkedItems[key]);
  };

  const [show, setShow] = React.useState(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const [success, setSuccess] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState("");
  const [buttonSpinner, setButtonSpinner] = React.useState(false);

  const postPublicationsList = async () => {
    setButtonSpinner(true);
    
    return await fetch.post(END_POINTS.PUBLICATION_SUBSCRIPTION_BULK, getCheckedItems())
    .then((res) => {      
      setShowMessage(intl.formatMessage({ id: "successfully-subscribe" }));
      setSuccess(true);
      setButtonSpinner(false);
      handleShow();
    })
    .catch((error) => {
      setShowMessage(intl.formatMessage({ id: "error-subscribe" }));
      setSuccess(false);
      setButtonSpinner(false);
      handleShow();
    });
  };
  

  return (
    <ContentLoading
      isLoading={getDepartment.isLoading || getServices.isLoading}
    >
      <div className="data-request">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "newsletters" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "newsletters-service" })}
          route={"../servicestools"}
        />
        <div className="container py-5">
          <div className="row gx-lg-5 gx-0">
            <div className="col-12 col-lg-8">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="newsletters-title" />
                </h3>
                <p className="m__title-desc">
                  <FormattedMessage id="newsletters-desc" />
                </p>
                <div className="mb-4 d-flex justify-content-end">
                  <input
                    className="form-control w-50"
                    type="search"
                    name="search"
                    id="search"
                    placeholder={`${intl.formatMessage({
                      id: "search-publication-name",
                    })}`}
                    onChange={(e) => {
                      setPublicationFilterText(e.target.value);
                      if(e.target.value) {
                        setExpanded(`panel${0}`);
                      }
                      else {
                        setExpanded(``);
                      }
                    }}
                  />
                </div>
                <div className="OrganizationalChart-coll">
                  {Object.keys(renderPublicationsData()).length > 0 ? (
                    renderPublicationsData()
                  ) : (
                    <DataNotFound />
                  )}
                </div>
                <div className="d-flex gap-3 justify-content-end mt-5">
                  <button className="main-btn" onClick={postPublicationsList}>
                    {buttonSpinner ? 
                      <span>
                        <CircularProgress sx={{ color: "#fff" }} size={26} />
                      </span>
                      :
                      <>
                        <span>
                          <FormattedMessage id="save" />{" "}
                          <ChevronIcon width={20} height={10} />
                        </span>
                      </>
                    }
                  </button>
                  <button className="second-btn bg-danger" onClick={() => {
                      setCheckedItems({});
                      setSelectAll({});
                    }}
                  >
                    <span>
                      <FormattedMessage id="cancel-all" />{" "}
                      <ClearIcon sx={{ color: "#fff" }} />
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <SnackbarModal
                open={show}
                onClose={handleClose}
                severity={success ? "success" : "error"}
                message={showMessage}
              />

            <div className="col-12 col-lg-4">
              <AboutDepartment
                id={"about"}
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
              <div className="mt-5">
                <MainDepartment getDepartment={getDepartment} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Newsletters;
